import React, { Component } from 'react';
import { Route, Link } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';

import Lang from '../../languages';
import { getRoutes } from '../../routes';

class MyBreadcrumb extends Component {
 constructor(props) {
  super(props);

  this.findRouteName = this.findRouteName.bind(this);
  this.getPaths = this.getPaths.bind(this);
  this.BreadcrumbsItem = this.BreadcrumbsItem.bind(this);
  this.Breadcrumbs = this.Breadcrumbs.bind(this);
 }

 findRouteName(url) {
  return getRoutes(this.props.session.language).find(i => i.path === url);
 }

 getPaths(pathname) {
  const paths = ['/'];

  if (pathname === '/') return paths;
  pathname.split('/').reduce((prev, curr, index) => {
   const currPath = `${prev}/${curr}`;
   paths.push(currPath);
   return currPath;
  });

  return paths;
 }

 BreadcrumbsItem({ match }) {
  const routeName = this.findRouteName(match.url);

  if (routeName) {
   return (
    match.isExact
     ? (<BreadcrumbItem active>{routeName.name}</BreadcrumbItem>)
     : (<BreadcrumbItem><Link to={match.url || ''}>{routeName.name}</Link></BreadcrumbItem>)
   );
  }

  return null;
 }

 Breadcrumbs({ location: { pathname }, match }) {
  const paths = this.getPaths(pathname);
  const items = paths.map((path, i) => <Route key={i++} path={path} component={this.BreadcrumbsItem} />);

  return (
   <Breadcrumb>
    {items}
   </Breadcrumb>
  );
 }

 render() {
  return (
  <div>
   <Route path="/:path" component={this.Breadcrumbs} {...this.props} />
  </div>
  )
 }

}



export default MyBreadcrumb;


// WEBPACK FOOTER //
// ./websources/containers/DefaultLayout/breadcrumb.js